import {Mapper} from '@s-ui/domain'

const PAGE_TYPE = {
  SIMILAR_ADS: 'similar-ads'
}

/**
 * @implements Mapper
 */
export default class TrackingUserFavoritesMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} param
   * @param {Object} param.config
   * @param {Object} param.fromPageTrackingJsonToTrackingDataValueObjectMapper
   * @param {Object} param.fromPageTrackingJsonToAdvertisementsValueObjectMapper
   */
  constructor({
    config,
    fromPageTrackingJsonToTrackingDataValueObjectMapper,
    fromPageTrackingJsonToAdvertisementsValueObjectMapper,
    fromSearchJSONToFiltersTrackingMapper
  }) {
    super()

    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._fromPageTrackingJsonToTrackingDataValueObjectMapper = fromPageTrackingJsonToTrackingDataValueObjectMapper
    this._fromPageTrackingJsonToAdvertisementsValueObjectMapper = fromPageTrackingJsonToAdvertisementsValueObjectMapper
    this._fromSearchJSONToFiltersTrackingMapper = fromSearchJSONToFiltersTrackingMapper
  }

  _getProductsFrom({advertisements, listType}) {
    const ads = advertisements.map(ad => ({
      ...ad,
      price: 0,
      quantity: 0
    }))

    const {products} = this._fromPageTrackingJsonToAdvertisementsValueObjectMapper
      .setParams({
        adsTypeName: 'ad_impression',
        listType,
        context: 'favoritesList'
      })
      .map({
        ads
      })
      .toJSON()

    return products
  }

  getFiltersTrackingData = ({lastFilter, search}) => {
    const {filters: searchFilters, lastFilter: searchLastFilter} = this._fromSearchJSONToFiltersTrackingMapper.map({
      lastFilter,
      search: {sortBy: search.sortBy, sortOrder: search.sortOrder}
    })

    return {
      last_filter: searchLastFilter,
      filters: searchFilters
    }
  }

  getTrackingData = ({advertisements = [], contactType, lastFilter, pageType, search, ...trackingData}) => {
    const {LIST_VIEW_EVENT, TRACKING_TRANSLATIONS_BY_CULTURE} = this._config.get('tracking')

    const TRACKING_LITERALS = TRACKING_TRANSLATIONS_BY_CULTURE[this._culture]
    const isSimilarAds = pageType === PAGE_TYPE.SIMILAR_ADS

    const listType = isSimilarAds
      ? TRACKING_LITERALS.USER_FAVORITE_RECOMMENDED_ADS_POPUP_LIST_TYPE
      : TRACKING_LITERALS.USER_FAVORITE_ADS_TYPE

    const products = this._getProductsFrom({advertisements, listType})

    if (isSimilarAds) {
      return {
        ...trackingData,
        page_name: TRACKING_LITERALS.ADS_DETAIL_RELATED_ADS_POPUP_PAGE_NAME,
        page_type: 'popup',
        event: LIST_VIEW_EVENT,
        list_type: TRACKING_LITERALS.USER_FAVORITE_RECOMMENDED_ADS_POPUP_ROOT_LIST_TYPE,
        products,
        page_category_level2:
          contactType === 'phoneCall'
            ? TRACKING_LITERALS.ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_CALL
            : TRACKING_LITERALS.ADS_DETAIL_RELATED_ADS_POPUP_CONTACT_TYPE_MAIL
      }
    }

    return {
      ...trackingData,
      ...(search && {...this.getFiltersTrackingData({lastFilter, search})}),
      ...(Object.keys(products).length && {products})
    }
  }

  /**
   * @param {Object} param
   * @param {String} param.page
   * @param {String} param.culture
   * @param {Object} param.data
   * @param {Object} param.data.advertisements
   */
  map({page, culture, data}) {
    return this._fromPageTrackingJsonToTrackingDataValueObjectMapper
      .setParams({page, culture})
      .map(this.getTrackingData(data))
  }
}
